import {useNavigate, useParams} from 'react-router-dom';
import {IInputShopAdvertisements} from '../../../services/hookService/getAvailableStoreAdsByInput/types';
import EditBasketButton from '../../shopping-basket/components/EditBasketButton';
import PriceWithDiscount from '../../shopping-basket/components/PriceWithDiscount';
import {CodeToInputGroupName} from '../myFavouriteAdd/card/helper';
import {getInputGroupIconById} from '../../../utilities/helper/inputGroupIcon/getInputGroupIcon';

interface ProductShopItemCardProps {
  item: IInputShopAdvertisements;
  isAvailable: boolean;
  saleMethod: number[];
}

const ProductShopItemCard = ({
  item,
  isAvailable,
  saleMethod,
}: ProductShopItemCardProps) => {
  const {
    main_image,
    sub_brand_main_image,
    title,
    min_sell_quantity,
    ad_price,
    discount_price,
    hold_quantity,
    available_quantity,
    quantity_pack_unit,
    id,
    basket_quantity,
    basket_guid,
  } = item;
  const navigate = useNavigate();
  const {selectedInputGroup} = useParams();
  const defaultInputGroupIcon = getInputGroupIconById({selectedInputGroup});
  const mainImage = main_image ?? sub_brand_main_image ?? defaultInputGroupIcon;

  const handleOnclick = () => {
    if (!selectedInputGroup) return;

    navigate(
      `/category-card-detail/${
        CodeToInputGroupName[+selectedInputGroup]
      }/${id}`,
    );
  };

  return (
    <div
      className="flex relative z-10 flex-col gap-2 items-center p-3 w-full h-full rounded-xl border border-gray-100 shadow-sm min-h-64"
      onClick={handleOnclick}
    >
      {!isAvailable && (
        <span className="absolute left-3 top-4 text-sm text-red-500">
          ناموجود
        </span>
      )}

      <img
        src={mainImage}
        alt="product_image"
        className="object-cover w-14 h-14 rounded-full"
      />

      {title && (
        <span className="font-medium text-center text-md line-clamp-2">
          {title}
        </span>
      )}

      <div className="flex items-center min-h-12">
        {ad_price ? (
          <PriceWithDiscount
            className="col-span-2"
            originalPrice={ad_price}
            discountPrice={discount_price}
          />
        ) : (
          <span className="font-medium text-md text-gray-950">قیمت توافقی</span>
        )}
      </div>

      <span className="text-sm font-medium px-0.5 bg-farm-shop-50 text-lime-700 mb-2 text-center">
        {min_sell_quantity ? (
          <>حداقل خرید {min_sell_quantity.toLocaleString()} عدد</>
        ) : (
          'حداقل خرید تعیین نشده'
        )}
      </span>

      {isAvailable && (saleMethod?.includes(3) || saleMethod?.includes(4)) ? (
        <div onClick={e => e.stopPropagation()} className="mt-auto w-full">
          <EditBasketButton
            variant="md"
            min_sell_quantity={min_sell_quantity}
            available_quantity={available_quantity}
            hold_quantity={hold_quantity}
            basket_quantity={basket_quantity}
            basket_guid={basket_guid}
            price={ad_price}
            advertisement_id={id}
          />
        </div>
      ) : (
        <div className="flex gap-1 justify-center items-center py-2 mt-auto w-full text-white rounded-lg bg-farm-shop-500 text-md">
          <span>مشاهده</span>
        </div>
      )}
    </div>
  );
};

export default ProductShopItemCard;
